import { init as npmInit, echarts as npmEcharts, helper as npmHelper } from 'thsc-datav-standard-chart';

const globalStd: any = (globalThis as any).ThsDataVStandardChart ?? {};

export const init = (npmInit as any) ?? globalStd?.init;
export const echarts = (npmEcharts as any) ?? globalStd?.echarts;
export const helper = (npmHelper as any) ?? globalStd?.helper;
